import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A08CBFD8-DD21-47F9-B213-7EF3AD89EDAD
 * name flask-round-bottom-empty
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flask-round-bottom-empty.svg
 * tags
 * - Science 
 */
export const FlaskRoundBottomEmptyIcon = createSvgIcon(<><path d="M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15Z" /></>, 'FlaskRoundBottomEmptyIcon');
export default FlaskRoundBottomEmptyIcon